import { render, staticRenderFns } from "./LevelsForm.vue?vue&type=template&id=3feb47c5&scoped=true"
import script from "./LevelsForm.vue?vue&type=script&lang=js"
export * from "./LevelsForm.vue?vue&type=script&lang=js"
import style0 from "./LevelsForm.vue?vue&type=style&index=0&id=3feb47c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feb47c5",
  null
  
)

export default component.exports